export const SHARED = 'shared'
export const STANDALONE = 'standalone'

export const NODE_ENV_TEST = 'test'

export const NOTIFICATION_CATEGORIES = {
  CRITICAL: 'Critical',
  PROMOTION: 'Promotion',
  SYSTEM: 'System',
  ACADEMY: 'Academy',
  PERSONALIZED: 'Personalized',
}

export const GREEN_REFERENCE_COLORS = ['G', 'DB', 'DG']
